import {
  convertLegacyPlugin,
  convertLegacyPageExtension,
} from '@backstage/core-compat-api';
import {
  ApiBlueprint,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import {
  s3ViewerPlugin,
  S3ViewerPage,
  S3ApiRef,
  S3Client,
} from '@spreadshirt/backstage-plugin-s3-viewer';

const s3ViewerApi = ApiBlueprint.make({
  name: 's3-viewer',
  params: define =>
    define(
      createApiFactory({
        api: S3ApiRef,
        deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
        factory: ({ discoveryApi, fetchApi }) =>
          new S3Client({ discoveryApi, fetchApi }),
      }),
    ),
});

// Plugin legacy sem entrypoint /alpha, com página própria e RouteRef
// interno — convertLegacyPlugin/convertLegacyPageExtension é o adaptador
// oficial pra isso (diferente do EntityCardBlueprint em
// legacyEntityCards.tsx, que é pra card/content ligado a entity, não
// página standalone).
//
// Escopo de bucket restrito de propósito em app-config.yaml (s3.allowedBuckets)
// — só bucket sem dado sensível (sem user-documents/backup/financial/PII).
// Ver docs/operacao.md antes de adicionar qualquer bucket novo à lista.
export const s3ViewerModule = convertLegacyPlugin(s3ViewerPlugin, {
  extensions: [
    s3ViewerApi,
    convertLegacyPageExtension(S3ViewerPage, { path: '/s3-viewer' }),
  ],
});
